/**
 * Flows represent (Shows, Schedules, and Lists)
 *
 * These constants are used to differentiate between the different flows in the
 * app.
 */

const displayShow = 'show';
const displaySchedule = 'schedule';
const displayList = 'list';
const displayGlobalElementContainer = 'globalElementContainer';

const showDesc =
  'An advanced show run down with auto time, ' +
  'per user column orders & show caller tracking.';

const scheduleDesc =
  'Create your production, rehearsal & general event ' +
  'schedules together in real time.';

const listDesc =
  'Quickly create & share a list with your team including ' +
  'contact, gear, vendor list & more.';

const getImportDesc = (type) =>
  `Import a CSV that will be created as a new ${type}`;

export const DisplayTypes = {
  show: displayShow,
  schedule: displaySchedule,
  list: displayList,
  globalElementContainer: displayGlobalElementContainer,
};

export const FlowDescriptions = {
  show: showDesc,
  schedule: scheduleDesc,
  list: listDesc,
};

export const FlowImportDescriptions = {
  show: getImportDesc(displayShow),
  schedule: getImportDesc(displaySchedule),
  list: getImportDesc(displayList),
};
